import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { FacebookShareButton, FacebookIcon } from 'react-share';
import {
    CommunityContext,
    PageContext,
} from '../../../../contexts/ContextCreator';
import './SmallFacebookButton.scss';
import { SHARE_DESTINATIONS } from '../CommunityShareButton/CommunitySharePopup/consts';

const SmallFacebookButton = ({ hash, urlToShare, beforeOnClick, label }) => {
    const { isLoggedIn, wrapAuth } = useContext(PageContext);
    const { getContent } = useContext(CommunityContext);
    const content = getContent(hash);
    const shareUrl = urlToShare || content.contentUrl;
    const labelCopy = label || 'Facebook';
    const authMetrics = {
        login_trigger: 'facebook-share',
        community_content_key: `${content.type}-${content.hash}`,
        community_on_comment: content.type === 'community-comment',
    };
    return wrapAuth(
        `facebook-share-${content.hash}`,
        <FacebookShareButton
            className="component-Community-ReactionBar-SmallFacebookButton"
            url={shareUrl}
            resetButtonStyle={false}
            beforeOnClick={() => beforeOnClick(SHARE_DESTINATIONS.FACEBOOK)}
            disabled={!isLoggedIn()}
            disabledStyle={{ opacity: 1 }}
        >
            <div className="icon-container">
                <FacebookIcon size={25} round />
            </div>
            <p className="label">{labelCopy}</p>
        </FacebookShareButton>,
        authMetrics
    );
};

SmallFacebookButton.propTypes = {
    hash: PropTypes.string.isRequired,
    urlToShare: PropTypes.string,
    beforeOnClick: PropTypes.func,
    label: PropTypes.string,
};

SmallFacebookButton.defaultProps = {
    urlToShare: null,
    beforeOnClick: () => {},
    label: null,
};

SmallFacebookButton.displayName = 'SmallFacebookButton';

export default React.memo(SmallFacebookButton);
